exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cp-title {\n  padding-left: 14px;\n  height: 16px;\n  font-size: 14px;\n  font-weight: bold;\n  color: #666;\n  line-height: 16px;\n  position: relative;\n}\n.cp-title:before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 4px;\n  height: 16px;\n  background-color: #be1e34;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader/dist/cjs.js?{"modifyVars":{"@primary-color":"#3296FA"}}!./src/components/title/index.less
// module id = 434
// module chunks = 0